const generateRexEx = (providedTransformation) => {
  const protocolAndDomain = '^https?://res[^.]*.cloudinary.com/';
  const pathSection = '(?:[^/]+/)';

  const prefixCName = `(?:(?!${protocolAndDomain})(^https?://[^/]*/)(${pathSection}{2}))`;
  const prefixNoCName = `(?:(?=${protocolAndDomain})(${protocolAndDomain})(${pathSection}{3}))`;
  const prefix = `(?:${prefixNoCName}|${prefixCName})`;
  const signature = '(s--.+--/)';
  const version = '(v[\\d]{8,}/)';
  const transformation = `(${providedTransformation}/)`;
  const publicId = '(.+?)';

  return new RegExp(`${prefix}${signature}?${transformation}?${version}?${publicId}$`);
};

export const parseUrl = (url = '', providedTransformation = '') => {
  const regEx = generateRexEx(providedTransformation);
  const [prefix1, kind1, prefix2, kind2, signature, transformation, version, publicId] = (url.match(regEx) || []).splice(1);

  return {
    prefix: prefix1 || prefix2,
    kind: kind1 || kind2,
    signature,
    transformation: transformation && decodeURIComponent(transformation),
    version,
    publicId: decodeURIComponent(publicId),
  };
};
